import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DashboardRoutes = defineRoute({
    index: {
        route: {
            path: "/",
            component: () => loadView(import("./DashboardPage.vue")),
        },
    },
});
